import { fromFetch } from 'rxjs/fetch';

import { requiredHeaders } from '../../../models/required-headers';
import { selectBlob } from '../../../utils/select-blob';
import { withJwt } from '../../../utils/with-jwt';
import { fleetStatsEnvironment } from '../fleet-stats-environment';

/**
 * Gets asset time to activation records in a csv form
 * @param startDate The start time of the request
 * @param endDate The end time of the request
 * @param metricType 0 for asset assignment, 1 for asset activation
 * @param partnerId ID of the partner
 * @param accountAlias Alias of the account
 * @param resultSmoothing Number designating amount of smoothing to apply to the result
 * @returns Asset Time to Activation Records CSV
 */
export function getDashboardAccountStatsExportTTAAssets(
  this: unknown,
  startDate: Date,
  endDate: Date,
  metricType: number,
  partnerId?: null | string,
  accountId?: null | number,
  resultSmoothing?: null | number
) {
  const queryParams = {
    startDate: startDate.toISOString(),
    endDate: endDate.toISOString(),
    metricType,
  };

  if (typeof partnerId === 'string') {
    Object.assign(queryParams, { partnerId });
  }

  if (typeof accountId === 'number') {
    Object.assign(queryParams, { accountId });
  }

  if (typeof resultSmoothing === 'number') {
    Object.assign(queryParams, { resultSmoothing });
  }

  const query = Object.entries(queryParams)
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join('&');

  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        `${
          fleetStatsEnvironment.resolve(this)
            .dashboardAccountStatsExportTTAAssetsUrl
        }?${query}`,
        {
          method: 'GET',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
        }
      )
    )
  ).pipe(selectBlob());
}
